// export const BASE_URL_SERVER =
//   'https://c9guzla9di.execute-api.us-east-2.amazonaws.com/dev';
// export const BASE_URL_SERVER = 'http://localhost:3000/dev';

//!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!! Old links !!!!!!!!!!!!!!

// export const BASE_URL_MAIN_SERVER = 'http://localhost:3005';

export const BASE_URL_MAIN_SERVER = 'https://api.datingclassifiedads.com';

export const AUTH_URL = BASE_URL_MAIN_SERVER + '/auth';

export const ADMINS = ['6707ff6685993a06a42027af'];
export const MANAGERS = ['678fc7641b623fea3cdf9d24'];

export const ONE_MINUTE = 1000 * 60;
export const ONE_HOUR = ONE_MINUTE * 60;
export const ONE_DAY = ONE_HOUR * 24;
export const CHAT_SESSION = ONE_MINUTE * 10;
export const VIDEO_SESSION = ONE_MINUTE * 10;
export const VOICE_SESSION = ONE_MINUTE * 10;
